<template>
  <div class="demo-app">
    <b-card
      no-body
      class="calendar-container"
    >
      <b-overlay
        :show="isLoading"
        rounded="sm"
      >
        <div class="calendar-wrapper">
          <!-- Thêm checkbox "Thời khóa biểu của tôi" nếu là Home view -->
          <div v-if="showForMeFilter" class="calendar-header-custom">
            <b-form-checkbox
              v-if="!!user.teacherId"
              v-model="forMeFilter"
              class="mb-1"
              @change="handleForMeFilter"
            >
              Thời khóa biểu của tôi
            </b-form-checkbox>
          </div>
          <FullCalendar
            ref="fullCalendar"
            :options="calendarOptions"
          >
            <template v-slot:eventContent="arg">
              <div class="event-content">
                <template v-if="isMonthView(arg.view)">
                  <div class="event-title-month">
                    <span>{{ arg.event.title }}</span>
                    <span class="event-class-code-month">
                      <feather-icon
                        icon="HashIcon"
                        size="10"
                        class="event-icon"
                      />
                      {{ arg.event.extendedProps.classCode }} - {{ arg.event.extendedProps.room }}
                    </span>
                  </div>
                </template>
                <template v-else>
                  <div class="event-header">
                    <div class="event-time">
                      <feather-icon
                        icon="ClockIcon"
                        size="18"
                        class="feather-icon"
                      />
                      <span>{{ arg.timeText }}</span>
                    </div>
                    <div class="event-title">
                      <feather-icon
                        icon="BookOpenIcon"
                        size="18"
                        class="feather-icon"
                      />
                      <span>{{ arg.event.title }}</span>
                    </div>
                  </div>
                  <div class="event-details">
                    <div
                      v-if="arg.event.extendedProps.teacher"
                      class="event-detail-row"
                    >
                      <feather-icon
                        icon="UserCheckIcon"
                        size="16"
                      />
                      <span class="event-teacher">{{ arg.event.extendedProps.teacher }}</span>
                    </div>
                    <div
                      v-if="arg.event.extendedProps.room"
                      class="event-detail-row"
                    >
                      <feather-icon
                        icon="HomeIcon"
                        size="16"
                      />
                      <span class="event-room">{{ arg.event.extendedProps.room }}</span>
                    </div>
                    <div
                      v-if="arg.event.extendedProps.classCode"
                      class="event-detail-row"
                    >
                      <feather-icon
                        icon="HashIcon"
                        size="16"
                        class="event-icon"
                      />
                      <span class="event-class-code">{{ arg.event.extendedProps.classCode }}</span>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </FullCalendar>
        </div>
      </b-overlay>
    </b-card>
  </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import viLocale from '@fullcalendar/core/locales/vi'
import {
  BCard, BOverlay, BFormCheckbox,
} from 'bootstrap-vue'
import api from '@/views/scheduler/api'
import '@/assets/scss/_fullCalendar.scss'
import apiHome from '@/views/apiHome'

export default {
  name: 'SchedulerCalendar',
  components: {
    BOverlay,
    BCard,
    BFormCheckbox,
    FullCalendar,
  },
  props: {
    filter: {
      type: Object,
      required: true,
    },
    activeTab: {
      type: Number,
      default: 0,
    },
    // Thêm props mới để phân biệt nguồn dữ liệu
    isHomeView: {
      type: Boolean,
      default: false,
    },
    showForMeFilter: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoading: false,
      turns: [],
      fetchTimeout: null, // Thêm timeout để debounce
      forMeFilter: false, // Thêm state cho checkbox "Thời khóa biểu của tôi"
      // Cache để tránh gọi API trùng lặp
      cache: {
        data: [],
        filterHash: null,
        lastFetch: null,
      },
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        timeZone: 'Asia/Ho_Chi_Minh',
        weekNumbers: true,
        datesSet: this.handleDatesSet,
        initialView: 'timeGridWeek',
        allDaySlot: false,
        slotMinTime: '07:00:00',
        slotMaxTime: '22:00:00',
        slotDuration: '00:30:00',
        slotLabelInterval: '01:00:00',
        nowIndicator: true,
        weekends: true,
        firstDay: 1,
        locale: { ...viLocale, weekText: 'Tuần' },
        height: 'auto',
        contentHeight: 'auto',
        selectable: false,
        slotEventOverlap: true,
        eventOverlap: true,
        editable: false,
        eventClick: this.handleEventClick,
        expandRows: false,
        aspectRatio: 1.5,
        eventMinHeight: 20,
        eventDisplay: 'auto',
        slotLabelFormat: { hour: '2-digit', minute: '2-digit', hour12: false },
        eventTimeFormat: { hour: '2-digit', minute: '2-digit', hour12: false },
        eventClassNames: 'custom-event-style',
        dayHeaderFormat: {
          weekday: 'long', day: 'numeric', month: 'numeric', separator: ' ngày ', omitYear: true,
        },
        headerToolbar: { left: 'prev,next today', center: 'title', right: 'dayGridMonth,timeGridWeek,timeGridDay' },
        views: {
          dayGridMonth: { dayHeaderFormat: { weekday: 'short' }, titleFormat: { year: 'numeric', month: '2-digit' } },
          timeGridWeek: { titleFormat: { day: '2-digit', month: '2-digit', year: 'numeric' } },
          timeGridDay: { titleFormat: { day: '2-digit', month: '2-digit', year: 'numeric' } },
          eventColor: '#a4bdfc',
          eventBackgroundColor: '#a4bdfc',
          eventBorderColor: 'rgba(0, 0, 0, 0.1)',
          eventTextColor: '#333',
        },
        events: [],
        eventDidMount: this.handleEventMount,
      },
    }
  },
  watch: {
     filter: {
      handler() {
        // Sử dụng debounce để tránh fetch liên tục
        if (this.fetchTimeout) {
          clearTimeout(this.fetchTimeout)
        }
        this.fetchTimeout = setTimeout(() => {
          this.fetchSchedule()
        }, 300) // Delay 300ms
      },
      deep: true,
    },
    activeTab: {
      handler(newVal) {
        // Chỉ khởi tạo lại calendar khi chuyển tab, không fetch dữ liệu
        this.$nextTick(() => {
          this.initializeCalendar()
        })
      },
      immediate: true,
    },
  },
  async created() {
    await this.fetchTurns()
    await this.fetchSchedule()
  },

  mounted() {
    // Đảm bảo calendar được khởi tạo đúng cách
    this.$nextTick(() => {
      try {
        this.initializeCalendar()
      } catch (error) {
        console.error('Error initializing calendar:', error)
      }
    })
  },

  beforeDestroy() {
    // Cleanup calendar khi component bị destroy
    try {
      // Clear timeout
      if (this.fetchTimeout) {
        clearTimeout(this.fetchTimeout)
      }

      if (this.$refs.fullCalendar) {
        const calendarApi = this.$refs.fullCalendar.getApi()
        if (calendarApi) {
          calendarApi.destroy()
        }
      }
    } catch (error) {
      console.error('Error destroying calendar:', error)
    }
  },
  methods: {
    initializeCalendar() {
      // Khởi tạo calendar một cách an toàn
      this.$nextTick(() => {
        try {
          const calendarApi = this.$refs.fullCalendar?.getApi()
          if (calendarApi) {
            // Chỉ cập nhật size và render, không fetch dữ liệu
            calendarApi.updateSize()
            calendarApi.render()
          }
        } catch (error) {
          console.error('Error in initializeCalendar:', error)
        }
      })
    },

    // Tạo hash từ filter để so sánh cache
    getFilterHash() {
      const filterStr = JSON.stringify({
        yearId: this.filter.yearId,
        semesterId: this.filter.semesterId,
        majorId: this.filter.majorId,
        subjectName: this.filter.subjectName,
        creditClassCode: this.filter.creditClassCode,
        teacherId: this.filter.teacherId,
      })
      return btoa(filterStr) // Encode base64
    },

    // Kiểm tra cache có hợp lệ không
    isCacheValid() {
      const currentHash = this.getFilterHash()
      const now = Date.now()
      const cacheAge = now - (this.cache.lastFetch || 0)
      const maxCacheAge = 5 * 60 * 1000 // 5 phút

      return (
        this.cache.filterHash === currentHash &&
        this.cache.data.length > 0 &&
        cacheAge < maxCacheAge
      )
    },

    refreshCalendar() {
      // Method để refresh calendar khi được gọi từ component cha
      if (this.isCacheValid()) {
        console.log('Using cached data for calendar')
        this.processScheduleData(this.cache.data)
      } else {
        console.log('Cache invalid, fetching new data')
        this.fetchSchedule()
      }
    },

    handleDatesSet(dateInfo) {
      const { type, title } = dateInfo.view
      if (type === 'timeGridDay' || type === 'timeGridWeek') {
        try {
          // Bỏ phần lấy weekNumber và chỉ hiển thị ngày tháng
          if (type === 'timeGridDay') {
            document.querySelector('.fc-toolbar-title').textContent = dateInfo.start.toLocaleDateString('vi', {
              day: '2-digit', month: '2-digit', year: 'numeric',
            })
          } else {
            const adjustedEnd = new Date(dateInfo.end)
            adjustedEnd.setDate(dateInfo.end.getDate() - 1)
            document.querySelector('.fc-toolbar-title').textContent = `${dateInfo.start.toLocaleDateString('vi', {
              day: '2-digit', month: '2-digit', year: 'numeric',
            })} - ${adjustedEnd.toLocaleDateString('vi', { day: '2-digit', month: '2-digit', year: 'numeric' })}`
          }
        } catch (e) {
          // silent
        }
      } else {
        document.querySelector('.fc-toolbar-title').textContent = title
      }
    },
    isMonthView(view) {
      return view.type === 'dayGridMonth'
    },

    // Thêm method để xử lý checkbox "Thời khóa biểu của tôi"
    async handleForMeFilter(event) {
      if (this.isHomeView) {
        this.filter.teacherId = this.user && event ? this.user.teacherId : ''
        await this.fetchSchedule()
      }
    },
    getColorByClassCode(classCode) {
      if (!classCode) return '#a4bdfc'
      let hash = 0
      for (let i = 0; i < classCode.length; i++) {
        hash = classCode.charCodeAt(i) + ((hash << 5) - hash)
      }
      const colors = ['#4c78e6', '#5b85ff', '#6a92ff', '#3f65cc', '#2e52b3', '#1d3f99', '#8a5ce6', '#996aff', '#a878ff', '#7a4ecc', '#693bb3', '#582899', '#cc4e4e', '#db6060', '#ea7272', '#b34141', '#9a3434', '#812727', '#cc8033', '#db8f44', '#ea9e55', '#b36622', '#9a4c11', '#813300', '#3b8742', '#4a9651', '#59a560', '#307838', '#255f2e', '#1a4624', '#8b5a2b', '#9a693a', '#a97849', '#7a4b22', '#693c1b', '#582d14', '#6b5c8a', '#7a6a99', '#8978a8', '#5c4e7a', '#4b3f6b', '#3a305c', '#4a4a4a', '#5c5c5c', '#6e6e6e', '#404040', '#333333', '#262626']
      return colors[Math.abs(hash) % colors.length]
    },
    async fetchTurns() {
      try {
        this.turns = await apiHome.getTurns()
      } catch (error) {
        // silent
      }
    },
    async fetchSchedule() {
      // Kiểm tra cache trước khi fetch
      if (this.isCacheValid()) {
        this.processScheduleData(this.cache.data)
        return
      }

      // Tránh fetch liên tục
      if (this.isLoading) return

      this.isLoading = true
      try {
        // Lấy thông tin ngày hiện tại của calendar
        const calendarApi = this.$refs.fullCalendar?.getApi()
        let startAt = null
        let endAt = null

        if (calendarApi) {
          const currentView = calendarApi.view
          if (currentView.type === 'timeGridWeek' || currentView.type === 'timeGridDay') {
            startAt = currentView.currentStart.toISOString().split('T')[0]
            endAt = new Date(currentView.currentEnd.getTime() - 24 * 60 * 60 * 1000).toISOString().split('T')[0]
          } else if (currentView.type === 'dayGridMonth') {
            startAt = currentView.currentStart.toISOString().split('T')[0]
            endAt = new Date(currentView.currentEnd.getTime() - 24 * 60 * 60 * 1000).toISOString().split('T')[0]
          }
        }

        const params = {
          courseId: this.filter.courseId || '',
          courseSemesterId: this.filter.courseSemesterId || '',
          teacherId: this.filter.teacherId || '',
          // Thêm tham số startAt và endAt nếu có
          ...(startAt && { startAt }),
          ...(endAt && { endAt }),
        }

        // Sử dụng API khác nhau tùy theo view
        let response
        if (this.isHomeView) {
          // Sử dụng API của Home
          response = await apiHome.getSchedules({ ...this.filter, ...params })
          const data = response || []
          this.updateCache(data)
          this.processScheduleData(data)
        } else {
          // Sử dụng API của Scheduler
          const paramScheduler = {
            currentPage: 1,
            itemsPerPage: 9999999, // Load hết dữ liệu cho calendar
            yearId: this.filter.yearId || null,
            semesterId: this.filter.semesterId || null,
            majorId: this.filter.majorId || null,
            subjectName: this.filter.subjectName || '',
            creditClassCode: this.filter.creditClassCode || '',
          }
          response = await api.selectSchedulers({ ...paramScheduler })
          const data = (response && response.records) || []
          this.updateCache(data)
          this.processScheduleData(data)
        }
      } catch (error) {
        console.error('Error fetching schedule:', error)
        // silent
      } finally {
        this.isLoading = false
      }
    },

    // Cập nhật cache
    updateCache(data) {
      this.cache.data = data
      this.cache.filterHash = this.getFilterHash()
      this.cache.lastFetch = Date.now()
      console.log('Cache updated with', data.length, 'items')
    },

    // Phương thức để fetch dữ liệu khi thay đổi view thủ công
    async fetchScheduleForCurrentView() {
      await this.fetchSchedule()
    },
    processScheduleData(scheduleData) {
      if (!Array.isArray(scheduleData)) {
        console.warn('scheduleData is not an array:', scheduleData)
        this.calendarOptions.events = []
        return
      }

      const events = []
      const colorMap = {}

      scheduleData.forEach((item, index) => {
        try {
          if (!item || !item.creditClassCode) {
            console.warn(`Invalid schedule item at index ${index}:`, item)
            return
          }

          if (!colorMap[item.creditClassCode]) {
            colorMap[item.creditClassCode] = this.getColorByClassCode(item.creditClassCode)
          }

          const days = (item.groupDayIds || '').split(',').map(Number).filter(Boolean)
          const turnGroups = (item.groupTurnIds || '').split('|')

          days.forEach((dayId, dayIndex) => {
            const turnIds = (turnGroups[dayIndex] || '').split(',').map(Number).filter(Boolean)
            const allConsecutiveGroups = this.findAllConsecutiveGroups(turnIds)

            allConsecutiveGroups.forEach(group => {
              if (group.length > 0) {
                const firstTurn = this.turns.find(t => t.id === group[0])
                const lastTurn = this.turns.find(t => t.id === group[group.length - 1])

                if (firstTurn && lastTurn) {
                  // Sử dụng startAt và endAt từ API nếu có, nếu không thì sử dụng logic cũ
                  const eventStartRecur = item.startAt || this.getDefaultStartDate()
                  const eventEndRecur = item.endAt || this.getDefaultEndDate()

                  // Chuẩn hóa lại giờ theo đúng định dạng HH:mm:ss (dựa trên múi giờ local) để dùng cho FullCalendar và extendedProps
                  const startTimeStr = firstTurn.startAt ? this.formatTimeFromISO(firstTurn.startAt) : null
                  const endTimeStr = lastTurn.endAt ? this.formatTimeFromISO(lastTurn.endAt) : null

                  events.push({
                    title: item.subjectName,
                    daysOfWeek: [dayId],
                    // Các field này FullCalendar dùng để render ở view tuần/ngày (yêu cầu format HH:mm:ss)
                    startTime: startTimeStr,
                    endTime: endTimeStr,
                    extendedProps: {
                      teacher: item.teacherName,
                      room: item.roomName,
                      classCode: item.creditClassCode,
                      turnNames: group.map(turnId => this.turns.find(t => t.id === turnId)?.name).filter(Boolean).join(', '),
                      subjectCode: item.subjectCode,
                      creditClassId: item.creditClassId,
                      // Thêm thông tin mới từ API
                      start: startTimeStr,
                      end: endTimeStr,
                      roomId: item.roomId,
                      subjectId: item.subjectId,
                      teacherId: item.teacherId,
                      yearWeekId: item.yearWeekId,
                      yearWeekCode: item.yearWeekCode,
                      courseId: item.courseId,
                      courseSemesterId: item.courseSemesterId,
                      trainingSystemId: item.trainingSystemId,
                      departmentId: item.departmentId,
                      leaderDepartmentId: item.leaderDepartmentId,
                    },
                    color: colorMap[item.creditClassCode],
                    textColor: '#fff',
                    startRecur: eventStartRecur,
                    endRecur: eventEndRecur,
                  })
                }
              }
            })
          })
          console.log('events', events)
        } catch (error) {
          console.error(`Error processing schedule item at index ${index}:`, error, item)
        }
      })

      this.calendarOptions.events = events
      this.updateCalendarTimeRange()
    },
    findAllConsecutiveGroups(turnIds) {
      if (!turnIds || turnIds.length === 0) return []
      const sortedUniqueTurns = [...new Set(turnIds.map(Number))].sort((a, b) => a - b)
      const result = []
      let currentGroup = [sortedUniqueTurns[0]]
      for (let i = 1; i < sortedUniqueTurns.length; i++) {
        if (sortedUniqueTurns[i] > sortedUniqueTurns[i - 1] + 1) {
          result.push([...currentGroup])
          currentGroup = [sortedUniqueTurns[i]]
        } else {
          currentGroup.push(sortedUniqueTurns[i])
        }
      }
      if (currentGroup.length > 0) {
        result.push(currentGroup)
      }
      return result
    },
    formatTimeFromISO(isoString) {
      if (!isoString) return null
      const d = new Date(isoString)
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      return `${hours}:${minutes}:00`
    },
    updateCalendarTimeRange() {
      if (this.turns.length === 0) return
      try {
        this.$nextTick(() => {
          const calendarApi = this.$refs.fullCalendar?.getApi()
          if (calendarApi) {
            calendarApi.updateSize()
            calendarApi.render()
          }
        })
      } catch (error) {
        console.error('Error updating calendar time range:', error)
      }
    },
    getDefaultStartDate() {
      // Trả về ngày đầu tuần hiện tại nếu không có startAt từ API
      const today = new Date()
      const dayOfWeek = today.getDay()
      const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1) // Điều chỉnh để thứ 2 là đầu tuần
      const monday = new Date(today.setDate(diff))
      return monday.toISOString().split('T')[0]
    },

    getDefaultEndDate() {
      // Trả về ngày cuối tuần hiện tại nếu không có endAt từ API
      const today = new Date()
      const dayOfWeek = today.getDay()
      const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? 0 : 7) // Điều chỉnh để chủ nhật là cuối tuần
      const sunday = new Date(today.setDate(diff))
      return sunday.toISOString().split('T')[0]
    },
    handleEventClick(info) {
      try {
        const formatTime = date => {
          if (!date) return '--:--'
          const adjustedDate = new Date(date.getTime() - (7 * 60 * 60 * 1000))
          return adjustedDate.toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit', hour12: false })
        }

        const h = this.$createElement
        const messageVNode = h('div', {}, [
          h('h4', {}, info.event.title),
          h('br'),
          h('p', {}, `Mã lớp: ${info.event.extendedProps.classCode}`),
          h('p', {}, `Tiết: ${info.event.extendedProps.turnNames}`),
          h('p', {}, `Thời gian: ${formatTime(info.event.start)} - ${formatTime(info.event.end)}`),
          h('p', {}, `Phòng: ${info.event.extendedProps.room}`),
          h('p', {}, `Giảng viên: ${info.event.extendedProps.teacher}`),
        ])

        this.$bvModal.msgBoxOk(messageVNode, {
          title: 'Thông tin môn học',
          size: 'sm',
          okVariant: 'primary',
          centered: true,
        })
      } catch (error) {
        console.error('Error in handleEventClick:', error)
        this.$bvModal.msgBoxOk('Có lỗi xảy ra khi hiển thị thông tin môn học', {
          title: 'Lỗi',
          size: 'sm',
          okVariant: 'danger',
          centered: true,
        })
      }
    },
    handleEventMount(info) {
      try {
        info.el.classList.add('custom-event')
        if (info.event.start <= new Date() && info.event.end >= new Date()) {
          info.el.classList.add('current-event')
        }
      } catch (error) {
        console.error('Error in handleEventMount:', error)
      }
    },
  },
}
</script>

<style scoped>
.card-body {
  padding: 0px !important;
}
.calendar-container {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.calendar-wrapper {
  padding: 20px;
  min-height: 400px; /* Đảm bảo có chiều cao tối thiểu */
}
.event-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: hidden;
}
.event-header {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.event-time, .event-title {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
}
.event-time {
  font-weight: 400;
  font-size: 1.8em;
  color: #fff;
  border-bottom: 1px solid white
}
.event-title {
  font-size: 1.8em;
  font-weight: 400;
  color: #fff;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.event-title > .feather-icon {
  flex-shrink: 0;
}
.event-details {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.event-teacher, .event-room, .event-class-code {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex: 1;
}
.event-detail-row > .feather-icon {
  flex-shrink: 0;
}
.event-detail-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 1.2em;
  line-height: 1.2;
  min-width: 0;
}
.event-room {
  font-weight: 500;
}
.event-title-month {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 2px;
  font-size: 0.9em;
  line-height: 1.2;
}
.event-class-code-month {
  font-size: 0.8em;
  opacity: 0.8;
  font-weight: 500;
}
.fc-dayGridMonth-view .fc-event {
  font-size: 0.9em;
  padding: 1px 2px;
}
.fc-dayGridMonth-view .fc-event .fc-event-main {
  padding: 0;
}



/* Thêm CSS để tránh lỗi khi calendar chưa load xong */
.calendar-wrapper:empty::after {
  content: "Đang tải lịch...";
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
  color: #666;
  font-style: italic;
}

.calendar-header-custom {
  margin-bottom: 15px;
}

.for-me-checkbox {
  margin-right: 5px;
  vertical-align: middle;
}
</style>

<style>
.fc .fc-timegrid-slot { height: 2.5em; }
.fc .fc-col-header-cell { background-color: #f8f9fa; padding: 8px 0; }
.fc .fc-timegrid-axis { background-color: #f8f9fa; }
.fc .fc-timegrid-event { border-radius: 4px; box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
.fc .fc-timegrid-event .fc-event-main { padding: 4px; }
.custom-event-style { border-left: 4px solid; border-left-color: var(--fc-event-border-color); background-color: var(--fc-event-bg-color); transition: all 0.2s ease; }
.custom-event-style:hover { filter: brightness(1.1); box-shadow: 0 2px 5px rgba(0,0,0,0.15); }
.fc-event { border: 1px solid rgba(0, 0, 0, 0.1); opacity: 0.9; transition: all 0.2s ease; }
.fc-event:hover { opacity: 1; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); }
.fc-event .fc-event-main { padding: 4px; }
.fc-event, .fc-event a { color: #333 !important; text-decoration: none; }
.fc .fc-day-sat, .fc .fc-day-sun { background-color: #f9f9f9; }
.fc-dayGridMonth-view .fc-daygrid-week-number, .fc-timegrid-axis-cushion { display: none; }


</style>
